export const getfinalDataObj = (nodes, interruptions) => {
  return {
    start_node: nodes?.find((nd) => nd.id === "start-node").next,
    bot_responses: nodes
      ?.filter((nd) => nd.type === "botMsgNode")
      .reduce((obj, item) => {
        obj[item.id] = {
          id: item.id,
          prev: item.prev,
          type: item.type,
          data: item.data,
          imp_msg: item.imp_msg || false,
          filler_used: false,
          message: {
            en: item.message["en"].split(";").map((item) => item.trim()),
            hi: item.message["hi"].split(";").map((item) => item.trim()),
          },
          default_user_input: item.default_user_input,
          user_inputs: item.user_inputs.map((item) => {
            return {
              id: item.id,
              next: item.next,
              input: item.input.split(";").map((item) => item.trim()),
              message: item.message,
              action: item.action,
            };
          }),
          interruptions: item.interruptions,
          specific_interruptions: item.specific_interruptions,
        };
        return obj;
      }, {}),
    intermediate_start_and_stop_nodes: nodes
      ?.filter(
        (nd) =>
          (nd.type === "startNode" || nd.type === "stopNode") &&
          nd.id !== "start-node"
      )
      .reduce((obj, item) => {
        obj[item.id] = {
          id: item.id,
          type: item.type,
          prev: item.prev,
          next: item.next,
          data: item.data,
        };
        return obj;
      }, {}),
    interruptions: interruptions?.map((item) => {
      return {
        id: item.id,
        name: item.name,
        next: item.next,
        input: item.input.split(";").map((item) => item.trim()),
        message: {
          en: item.message["en"].trim()
            ? item.message["en"].split(";").map((item) => item.trim())
            : [],
          hi: item.message["hi"].trim()
            ? item.message["hi"].split(";").map((item) => item.trim())
            : [],
        },
        action: item.action,
      };
    }),
  };
};
